import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import RailText from '@/components/RailText'
import style from './style'

const useStyles = createUseStyles(style)

const RelatedProducts = ({
  title,
  items,
  label,
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className="relatedProducts__TitleWrapper">
        <div
          className={classes.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      {items.map((item, i) => (
        <div key={item.id}>
          <RailText
            className={classes.roll}
            title={item.title}
            link={item.link}
            image={item.image}
            reverse={(i % 2) === 1}
            label={label}
          />
          <div className={`${classes.separator} relatedProducts__separator`} />
        </div>
      ))}
    </div>
  )
}

RelatedProducts.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    link: PropTypes.string,
    image: PropTypes.string,
  })).isRequired,
}

export default RelatedProducts
